var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_2114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0779 5C16.6631 5 15.6426 6.00952 13.9608 6.00952C12.2359 6.00952 10.9207 5.00612 8.82931 5.00612C6.78103 5.00612 4.59619 6.10129 3.2091 7.96737C1.26143 10.5982 1.59203 15.554 4.74711 19.7757C5.87547 21.2869 7.38473 22.9816 9.36115 23H9.39708C11.1148 23 11.625 22.015 13.9896 22.0027H14.0255C16.3541 22.0027 16.8212 22.9939 18.5317 22.9939H18.5677C20.5441 22.9755 22.1324 21.0972 23.2608 19.5921C24.0729 18.5092 24.3747 17.9646 25 16.741C20.4363 15.2237 19.7032 9.55812 24.2166 7.38613C22.8367 5.87491 20.9034 5 19.0779 5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9541 0C16.6586 0.0757576 15.1494 0.784632 14.262 1.70996C13.4587 2.5487 12.798 3.79329 13.0571 5H13.1608C14.5405 5 15.9526 4.28571 16.7752 3.37121C17.572 2.5 18.1744 1.26623 17.9541 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_2114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple_icon.7f9bc5c49a705edb43c64348bfaf0d80.svg";
export { ForwardRef as ReactComponent };